var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilitary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/military") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,0.001 L35,4 L39.087,4 C40.191,4 41.087,3.105 41.087,2 C41.087,0.896 40.191,0.001 39.087,0.001 L35,0.001 Z M2,0.001 C0.896,0.001 0,0.895 0,2 C0,3.105 0.896,4 2,4 L24,4 L24,0.001 L2,0.001 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/military",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(17.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#BEC0C2",
    points: "0 23 51 23 51 8 0 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#116C3A",
    points: "-0.0001 8.0004 50.9999 8.0004 47.9999 0.0004 2.9999 0.0004"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#DEDFE1",
    points: "7 45 58 45 58 30.001 7 30.001"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#1D9042",
    points: "9.9997 22.0007 6.9997 30.0007 58.0007 30.0007 54.9997 22.0007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,36 L10,32 L13,32 L13,36 L10,36 Z M16,36 L16,32 L19,32 L19,36 L16,36 Z M22,36 L22,32 L25,32 L25,36 L22,36 Z M28,36 L28,32 L31,32 L31,36 L28,36 Z M34,36 L34,32 L37,32 L37,36 L34,36 Z M40,36 L40,32 L43,32 L43,36 L40,36 Z M46,36 L46,32 L49,32 L49,36 L46,36 Z M52,36 L52,32 L55,32 L55,36 L52,36 Z M34,42 L34,38 L37,38 L37,42 L34,42 Z M40,42 L40,38 L43,38 L43,42 L40,42 Z M46,42 L46,38 L49,38 L49,42 L46,42 Z M52,42 L52,38 L55,38 L55,42 L52,42 Z",
    id: "Combined-Shape",
    fill: "#53535C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(32.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9999,17.0004 L34.9999,17.0004 L34.9999,2.0004 C34.9999,0.8964 34.1039,0.0004 32.9999,0.0004 L25.9999,0.0004 C24.8959,0.0004 23.9999,0.8964 23.9999,2.0004 L23.9999,17.0004 Z",
    id: "Fill-19",
    fill: "#1D9042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0868,5.0004 C41.0868,3.8964 40.1908,3.0004 39.0868,3.0004 L34.9998,3.0004 L34.9998,7.0004 L39.0868,7.0004 C40.1908,7.0004 41.0868,6.1044 41.0868,5.0004 M1.9998,3.0004 L23.9998,3.0004 L23.9998,7.0004 L1.9998,7.0004 C0.8958,7.0004 -0.0002,6.1044 -0.0002,5.0004 C-0.0002,3.8954 0.8958,3.0004 1.9998,3.0004",
    id: "Fill-22",
    fill: "#E04622"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(32.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "11.9999 4.0004 6.9999 4.0004 10.9999 0.0004 15.9999 0.0004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "1.9999 4.0004 -3.0001 4.0004 0.9999 0.0004 5.9999 0.0004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "21.9999 4.0004 16.9999 4.0004 20.9999 0.0004 25.9999 0.0004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "34.9999 4.0004 29.9999 4.0004 33.9999 0.0004 38.9999 0.0004"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M28.9999,65.0004 L9.9999,65.0004 L9.9999,40.0004 C9.9999,38.8964 10.8959,38.0004 11.9999,38.0004 L26.9999,38.0004 C28.1039,38.0004 28.9999,38.8964 28.9999,40.0004 L28.9999,65.0004 Z",
    id: "Fill-38",
    fill: "#1D9042"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#303035",
    points: "17 51 26 51 26 42 17 42"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitary);
export default __webpack_public_path__ + "static/media/military.1c6408f5f5c3e8a3a8f0cc6b57c3eac4.svg";
export { ForwardRef as ReactComponent };